import { WebSocketService } from './websocketService';
import { chatApi } from '../api/chatApi';
import { bibleApi } from '../api/bibleApi';
import type { Chat } from '../types/chat';

export const chatService = {
    async createChat(content: string, userId: string): Promise<Chat> {
        return chatApi.createChat(content, userId);
    },

    async sendMessage(content: string, threadId: string, chatId: string): Promise<void> {
        const ws = WebSocketService.getInstance();
        await ws.send({
            type: 'chat_message',
            content,
            threadId,
            chatId
        });
    },

    async getVerseExplanation(verse: string) {
        const response = await bibleApi.post('/bible/explain', { verse });
        return response.data.explanation;
    },

    async generateFollowUpQuestions(chatId: string, content: string) {
        const response = await chatApi.post(`/chats/${chatId}/questions`, { content });
        return response.data.questions;
    },

    async tellMeMore(verse: string, threadId: string, chatId: string): Promise<void> {
        const ws = WebSocketService.getInstance();
        await ws.send({
            type: 'tell_me_more',
            verse,
            threadId,
            chatId
        });
    },

    async followUpQuestion(question: string, threadId: string, chatId: string): Promise<void> {
        const ws = WebSocketService.getInstance();
        await ws.send({
            type: 'follow_up_question',
            content: question,
            threadId,
            chatId
        });
    }
};